export default "__VITE_ASSET__148UZfZa__"